"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../utils/prop-types"));

var _convenience = require("../../../utils/convenience");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Distance = function Distance(props) {
  var distanceInKilometers = props.location.Distance.toFixed(2);
  var distanceInMiles = (distanceInKilometers * 0.621371).toFixed(2);
  var distanceValue = props.settings.Unit === 'KM' ? distanceInKilometers : distanceInMiles;
  return distanceValue;
};

var ListItem = function ListItem(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "locations-list-item ".concat(props.layoutType, " ").concat(props.index % 2 ? 'even' : 'odd', " ").concat(props.location.equals(props.selectedLocation) || props.location.equals(props.tempSelectedLocation) ? 'selected' : ''),
    onClick: function onClick(e) {
      var shouldDispatchHighlightTrackingEvent = e.target.id !== 'info-button';
      props.onSelectLocation(props.location, shouldDispatchHighlightTrackingEvent);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.code === "".concat(props.index + 1)) {
        props.onOpenLocation(props.location);
      }
    },
    role: "button",
    tabIndex: props.index
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "info"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, props.location.Name)), props.location.FormattedAddress && /*#__PURE__*/_react["default"].createElement("div", {
    className: "address"
  }, props.location.FormattedAddress.substr(0, 1) === ',' ? props.location.FormattedAddress.substr(2) : props.location.FormattedAddress), props.location.Phone && /*#__PURE__*/_react["default"].createElement("div", {
    className: "phone"
  }, props.settings.dictionary.phone, ":", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "tel:".concat(props.location.Phone),
    onClick: function onClick() {
      return props.onPhoneClick(props.location);
    }
  }, props.location.Phone)), props.location.OpeningHours && /*#__PURE__*/_react["default"].createElement("div", {
    className: "opening-hours"
  }, "".concat(props.settings.dictionary.openingHours, ": "), props.location.OpeningHours), /*#__PURE__*/_react["default"].createElement("div", {
    className: "distance"
  }, /*#__PURE__*/_react["default"].createElement("i", null, /*#__PURE__*/_react["default"].createElement(Distance, props), " ".concat(props.settings.Unit)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cta"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "details"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "button",
    id: "info-button",
    onClick: function onClick(e) {
      props.onOpenLocation(props.location, e);
      window.DGS.Event.getInstance().trigger('trackLocationsClinicClick', props.location.Name, props.location.PostalCode);
    }
  }, props.settings.dictionary.info))));
};

var _default = (0, _convenience.withTempSelection)(ListItem);

exports["default"] = _default;
ListItem.propTypes = {
  settings: _propTypes2["default"].settings.isRequired,
  location: _propTypes2["default"].location.isRequired,
  distance: _propTypes["default"].string.isRequired,
  tempSelectedLocation: _propTypes2["default"].location.isRequired,
  selectedLocation: _propTypes2["default"].location.isRequired,
  onSelectLocation: _propTypes2["default"].func.isRequired,
  onOpenLocation: _propTypes2["default"].func.isRequired,
  onPhoneClick: _propTypes["default"].func,
  layoutType: _propTypes2["default"].layoutType.isRequired,
  index: _propTypes["default"].number.isRequired
};
ListItem.defaultProps = {
  onPhoneClick: function onPhoneClick() {}
};